<!-- Display transaction history of customer -->
<!-- error message in case of unauthorised user -->
<ng-container *ngIf="role && role !== 'CUSTOMER'">
  <h1>UNAUTHORISED ACCESS</h1> <br>
  <h3>Please Login as CUSTOMER, redirecting ...</h3>
  {{unauthorised()}}
</ng-container>
<mat-spinner class="comeOnTop" *ngIf="pdfLoading"></mat-spinner>
<ng-container *ngIf="role && role === 'CUSTOMER'">
  <div class="wrapper ">
    <br>
    <div>
      <div class="content">
        <ng-container *ngIf="transactions">
          <div class="alert alert-danger" role="alert" *ngIf="transactions.length === 0">
            No transactions
          </div>
          <div id="trans" class="alert alert-primary" role="alert" *ngIf="transactions.length !== 0">
            Your Transactions
          </div>

          <div class="card">
          <div class="card-body">
            <div style="text-align: center;">
              <form [formGroup]="dateForm">
                <mat-form-field appearance="fill">
                  <mat-label>Pick a Date Range</mat-label>
                  <mat-date-range-input [rangePicker]="picker">
                    <input [readonly]=true formControlName="startDate" matStartDate placeholder="Start date">
                    <input [readonly]=true formControlName="endDate" matEndDate placeholder="End date">
                  </mat-date-range-input>
                  <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
                  <mat-date-range-picker #picker></mat-date-range-picker>
                </mat-form-field>&nbsp;&nbsp;
                <mat-form-field appearance="fill">
                  <mat-label>Select Purpose</mat-label>
                  <mat-select formControlName="selectedPurpose" required>
                    <mat-option *ngFor="let purpose of purposes" [value]="purpose">
                      {{ purpose }}
                    </mat-option>
                  </mat-select>
                </mat-form-field>
              </form>

              <button type="button" class="btn btn-success" (click)="filter()">FILTER</button>
              <button type="button" class="btn btn-warn" (click)="reset()">RESET</button>
              <mat-error *ngIf="missingFields">Date range field is required</mat-error>
              <br><br>
              <button *ngIf="alltransactions.length>0" type="button" class="btn btn-info" [disabled]='pdfLoading' (click)="sendInvoice()">GENERATE TRANSACTION REPORT</button>
            </div>
            <br>
            <table class="table table-hover">
              <thead class=" text-primary">
                <tr>
                  <th>Customer name</th>
                  <th>Date of Entry</th>
                  <th>Amount</th>
                  <th>Type</th>
                  <th>Purpose</th>
                  <!-- <th>Payment Mode</th> -->
                  <th>Date of Payment</th>
                  <th>Payment mode</th>
                  <th>Reference Number</th>
                  <th>Balance Remaining</th>
                  <!-- <th>Remarks</th> -->
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let transaction of transactions">
                  <td>{{customerName}}</td>
                  <td>{{transformDate(transaction.createdAt)}}</td>
                  <td>{{transaction.amount}}</td> 
                  <td>{{transaction.type}}</td>

                  <td>
                    <div *ngIf="transaction.type=='CREDIT'">
                        <div *ngIf="!transaction.purpose"> Details Unavailable</div>
                        <div *ngIf="transaction.purpose">{{transaction.purpose}}</div>
                    </div>
                    <div *ngIf="transaction.type=='DEBIT'">
                      <div *ngIf="!transaction.Purpose"> Details Unavailable</div>
                      <div *ngIf="transaction.Purpose">{{transaction.Purpose}}</div>
                  </div>
                  </td> 

                  <td>
                    <div *ngIf="transaction.type=='CREDIT'">
                      <div *ngIf="!transaction.date_of_payment"> Details Unavailable</div>
                      <div *ngIf="transaction.date_of_payment">{{transaction.date_of_payment}}</div>
                    </div>
                    <div *ngIf="transaction.type=='DEBIT'">
                      <div>Not applicable</div>
                    </div>
                  </td>  
                  
                  <td>
                    <div *ngIf="transaction.type=='CREDIT'">
                      <div *ngIf="!transaction.payment_mode"> Details Unavailable</div>
                      <div *ngIf="transaction.payment_mode">{{transaction.payment_mode}}</div>
                    </div>
                    <div *ngIf="transaction.type=='DEBIT'">
                      <div>Not applicable</div>
                    </div>
                  </td>

                  <td>
                    <div *ngIf="transaction.type=='CREDIT'">
                        <div *ngIf="!transaction.payment_reference"> Details Unavailable</div>
                        <div *ngIf="transaction.payment_reference">{{transaction.payment_reference}}</div>
                    </div>
                    <div *ngIf="transaction.type=='DEBIT'">
                      <div *ngIf="!transaction.Reference_Number"> Details Unavailable</div>
                      <div *ngIf="transaction.Reference_Number">{{transaction.Reference_Number}}</div>
                    </div>
                  </td>
                        
                  <td>{{transaction.balance}}</td>

                  <!-- <td>{{transaction.summary}}</td> -->
                </tr>
              </tbody>
            </table>
          </div>
          
        </div>
        </ng-container>
      </div>
    </div>
  </div>
</ng-container>

<!-- end of transaction display-->
